import React      from 'react';
import CSSModules from 'react-css-modules';

import style from './style.scss';

import classNames from 'classnames/bind';

import * as bookingActions from '../../actions/bookingList';

import bookingRepo       from '../../services/bookings';
import eventFormatter    from '../../services/eventFormatter';
import bookingFormatter  from '../../services/bookingFormatter';
import responseFormatter from '../../services/responseFormatter';
import promotionRepo     from '../../services/promotionCodes';
import bookingCalculator from '../../services/bookingCalculator';
import authenticator     from '../../services/authenticator';
import { setQueryParam, getQueryParam } from '../../services/queryString';

import Overlay          from '../Overlay';
import Button           from '../Button';
import MaterialIcon     from '../MaterialIcon';
import Input            from '../Input';
import InputGroup       from '../InputGroup';
import InputSection     from '../InputSection';
import InlineError      from '../InlineError';
import Label            from '../Label';
import SearchInput      from '../SearchInput';
import YesNoOptionPanel from '../YesNoOptionPanel';
import Checkbox         from '../Checkbox';
import TextArea         from "../TextArea";

import TransparentButton    from '../TransparentButton';

import RemoveTransactionDelegateOverlay from '../RemoveTransactionDelegateOverlay';

import { reduxForm } from 'redux-form';

class TransactionList extends React.Component {

    componentDidMount() {

        this.props.filterByReference(getQueryParam('referenceCode'));
        this.props.refreshStats();
        this.props.refreshBookings();
    }

    _statusChanged(booking, event) {

        const newStatus = event.target.value;

        this.props.updateBooking({
            id: booking.id,
            payment_method: booking.payment_method,
            status: newStatus
        });
    }

    _getCourseName(booking) {

        const deletedCourseText = "Course Deleted";

        if (booking.event) {

            return booking.event.course.name;
        }

        if (booking.e_learning) {

            return booking.e_learning.name + ' ' + '(E-Learning)';
        }

        return deletedCourseText;
    }

    _getSelectBoxClass(status) {

        var cx = classNames.bind(style);

        return cx({
            'booking-status':                   true,
            'booking-status--po':               status === 'requires_po',
            'booking-status--requires-invoice': status === 'requires_invoice',
            'booking-status--invoiced':         status === 'invoiced',
            'booking-status--complete':         status === 'complete'
        });
    }

    _getStatusSelectBox(booking) {

        if (booking.total_charge === '0') {

            return (
                <div className={ this._getSelectBoxClass(booking.status) }>
                    <select value={ booking.status } disabled={ true }>
                        <option value="complete">Complete</option>
                    </select>
                </div>
            );

        } else if (booking.payment_method === 'card') {

            return (
                <div className={ this._getSelectBoxClass(booking.status) }>

                    <select onClick={ (event) => event.stopPropagation() }
                            onChange={ this._statusChanged.bind(this, booking) }
                            value={ booking.status }>

                        <option value="requires_invoice">Requires Invoice</option>
                        <option value="invoiced">Invoiced</option>
                        <option value="complete">Complete</option>
                    </select>

                    <span styleName="select-arrow">&#9662;</span>
                </div>
            );

        } else if (booking.payment_method === 'invoice') {

            return (
                <div className={ this._getSelectBoxClass(booking.status) }>

                    <select onClick={ (event) => event.stopPropagation() }
                            onChange={ this._statusChanged.bind(this, booking) }
                            value={ booking.status }>

                        <option value="requires_po">Requires PO</option>
                        <option value="requires_invoice">Requires Invoice</option>
                        <option value="invoiced">Invoiced</option>
                        <option value="complete">Complete</option>
                    </select>

                    <span styleName="select-arrow">&#9662;</span>
                </div>
            );
        }
    }

    _updateBookingDetails(booking) {

        const bookingDetailsUpdated = this.props.bookingDetailsUpdated;
        const refreshBooking = this.props.refreshBookings;

        return new Promise((resolve, reject) => {

            function updateSuccess() {

                bookingDetailsUpdated();
                refreshBooking();
                resolve();
            }

            function updateFailed(response) {

                reject(responseFormatter.apiErrorsToFormErrors(response.data.errors));
            }

            bookingRepo.update(booking)
                .then(updateSuccess, updateFailed);
        });
    }

    _getBookingDetailsActions() {

        const paymentMethod = this.props.selectedBooking.payment_method;

        if (paymentMethod === 'invoice' || paymentMethod === 'card') {

            const { submitting } = this.props;

            return (
                <Button disabled={ submitting }
                        theme="success"
                        type="submit">
                    Save
                </Button>
            );
        }
    }

    _getInvoiceNumberSection() {

        const paymentMethod = this.props.selectedBooking.payment_method;


        if (paymentMethod === 'invoice' || paymentMethod === 'card') {

            const { fields: { invoice_number } } = this.props;

            return (
                <InputSection>
                    <InputGroup>
                        <Label>Invoice Number</Label>
                        <Input errors={ invoice_number.error } { ...invoice_number } />
                        <InlineError errors={ invoice_number.error }/>
                    </InputGroup>
                </InputSection>
            );
        }
    }

    _getInvoicesToSection() {

        const mailTo = 'mailto:' + this.props.selectedBooking.invoice_email;

        return (
            <InputGroup>
                <span>Invoices to</span> <a href={ mailTo }>{ this.props.selectedBooking.invoice_email }</a>
            </InputGroup>
        );
    }

    _getSector(sectorType) {

        switch (sectorType) {

            case 'public':
                return 'Public';

            case 'private':
                return 'Private';

            default:
                return 'Unknown';
        }
    }

    _getBookingEmail(email) {

        const mailTo = 'mailto:' + email;

        return (
            <div>
                <span>Booked by</span> <a href={ mailTo }>{ email }</a>
            </div>
        );
    }

    _getBillingAddressSection(booking) {

        if (booking.payment_method === 'invoice' || booking.payment_method === 'card') {

            if (booking.billing_address) {

                let countryName = null;

                if (booking.billing_address.country) {
                    countryName = booking.billing_address.country.name;
                }

                return (
                    <InputGroup styleName="booking-details__group">

                        <h3 styleName="booking-details__group-heading">Billing Address</h3>

                        <address>
                            <span styleName="line">{ booking.billing_address.address_1 }</span>
                            <span styleName="line">{ booking.billing_address.address_2 }</span>
                            <span styleName="line">{ booking.billing_address.town_city }</span>
                            <span styleName="line">{ booking.billing_address.post_code }</span>
                            <span styleName="line">{ countryName }</span>
                        </address>
                    </InputGroup>
                );
            }
        }
    }

    _getDiscounts(discounts) {

        return discounts.map((discount, index) => {

            return (
                <tr key={ index }>
                    <td>{ promotionRepo.typeToDescription(discount.type) }</td>
                    <td>-£{ parseFloat(discount.amount).toFixed(2) }</td>
                </tr>
            );
        });
    }

    _isElearningBooking() {
        return !!this.props.selectedBooking['course_id'] && !this.props.selectedBooking['event_id'];
    }

    _getBookingDetails() {

        const { handleSubmit } = this.props;

        if (this.props.isShowingBookingDetails) {

            const booking  = this.props.selectedBooking;
            const transactionDelegates = booking['transaction_delegates'];
            const attendees = booking['attendees'];

            let displayedVatRate = '20';

            if (this.props.selectedBooking.billing_address && this.props.selectedBooking.billing_address.country != null) {
                displayedVatRate = this.props.selectedBooking.billing_address.country.is_eu ? '20' : '0';
            }

            let readableReferrer = "";
            if(booking.referrer !== null) {
                switch(booking.referrer) {
                    case 'cant_remember':
                        readableReferrer = "Can't Remember";
                        break;
                    case 'invite':
                        readableReferrer = "Email Invitation";
                        break;
                    case 'magazine':
                        readableReferrer = "Magazine";
                        break;
                    case 'word_of_mouth':
                        readableReferrer = "Word of Mouth";
                        break;
                    case 'search':
                        readableReferrer = "Search Engine";
                        break;
                    default:
                        readableReferrer = null;
                        break;
                }
            }

            let formattedEvent;

            if (this.props.selectedBooking.event) {

                formattedEvent = eventFormatter.format(this.props.selectedBooking.event);
            }

            return (
                <form onSubmit={ handleSubmit(this._updateBookingDetails.bind(this)) }>

                    <InputGroup styleName="booking-details__group">

                        <h3 styleName="booking-details__group-heading">Organisation</h3>

                        <span styleName="booking-details__organisation-name">{ booking.organisation_name }</span>
                        <span styleName="line">{ this._getSector(booking.sector) } sector</span>

                        { this._getBookingEmail(booking.booking_email) }

                    </InputGroup>

                    <InputGroup styleName="booking-details__group">

                        <h3 styleName="booking-details__group-heading">Referrer</h3>

                        <span styleName="booking-details__referrer">{ booking.referrer === 'other' ? 'Other: ' + booking.other_referrer : readableReferrer ? readableReferrer : 'None given' }</span>

                    </InputGroup>

                    { formattedEvent &&

                    <InputGroup styleName="booking-details__group">

                        <div>
                            <h3 styleName="booking-details__group-heading">Course</h3>

                            <span styleName="line">Reference Code: { formattedEvent.reference_code }</span>
                            <span styleName="line">{ formattedEvent.course.name }</span>
                            <span styleName="line">{ formattedEvent.date_range }</span>
                            <span styleName="line">{ formattedEvent.venue_address_text }</span>
                        </div>

                    </InputGroup>

                    }

                    <InputGroup styleName="booking-details__group">

                        <h3 styleName="booking-details__group-heading">Delegates</h3>

                        <table>
                            <tbody>
                            {
                                transactionDelegates.map((delegate) => {

                                    let attendee = attendees.filter(
                                        attendee => attendee.first_name === delegate.first_name && attendee.last_name === delegate.last_name
                                    );

                                    return (
                                        <tr key={ delegate.id }>
                                            <td>
                                                { delegate.first_name } { delegate.last_name }
                                            </td>

                                            {attendee && attendee.length > 0 && attendee[0].phone && (
                                                <td styleName="phone-info">
                                                    { attendee[0].phone}
                                                </td>
                                            )}

                                            <td onClick={ this.props.selectDelegateForDeletion.bind(this, delegate) }
                                                style={{display: 'none'}}
                                                styleName="remove-delegate-button">
                                                Remove
                                            </td>
                                        </tr>
                                    );
                                })
                            }
                            </tbody>
                        </table>

                    </InputGroup>

                    <InputGroup styleName="booking-details__group">

                        <h3 styleName="booking-details__group-heading">Payment</h3>

                        {booking.price_overridden &&
                            <span styleName="line--hint">
                                The price per delegate was fixed at the time of this booking.
                            </span>
                        }

                        {!this._isElearningBooking() &&
                            <span styleName="line">
                                { transactionDelegates.length } x delegates @ £{ parseFloat(booking.price_per_delegate).toFixed(2) } per delegate
                            </span>
                        }

                        <table styleName="booking-details__charge-table">
                            <tbody>

                            {this._isElearningBooking() && transactionDelegates.map(delegate => {
                                return (
                                    <tr>
                                        <td>{ delegate.first_name } { delegate.last_name } {delegate.elearning_unit_count > 0 && `(Modules x ${delegate.elearning_unit_count})`}</td>
                                        <td>£{ delegate.place_value && parseFloat(delegate.place_value).toFixed(2) }</td>
                                    </tr>
                                )
                            })}

                            <tr>
                                <td>Subtotal</td>
                                <td>£{ parseFloat(booking.subtotal).toFixed(2) }</td>
                            </tr>

                            { this._getDiscounts(booking.discounts) }

                            <tr>
                                <td>Total (Ex VAT)</td>
                                <td>£{ bookingCalculator.calculateNetTotal(booking).toFixed(2) }</td>
                            </tr>

                            <tr>
                                <td>VAT ({displayedVatRate}%)</td>
                                <td>£{ parseFloat(booking.vat).toFixed(2) }</td>
                            </tr>

                            <tr>
                                <td>Total</td>
                                <td>£{ parseFloat(booking.total_charge).toFixed(2) }</td>
                            </tr>

                            </tbody>
                        </table>

                    </InputGroup>

                    { this._getBillingAddressSection(booking) }

                    { this._getInvoiceSection(booking) }

                    { this._getNotesSection() }

                </form>
            );
        }
    }

    _getPurchaseOrderSection() {

        if (this.props.selectedBooking.payment_method === 'invoice') {

            const { po_number } = this.props.fields;

            return (
                <InputGroup>
                    <Label>Purchase Order</Label>
                    <Input { ...po_number } errors={ po_number.error }/>
                    <InlineError errors={ po_number.error }/>
                </InputGroup>
            );
        }
    }

    _getInvoiceSection(booking) {

        if (booking.payment_method === 'invoice' || booking.payment_method === 'card') {

            return (
                <div>
                    <InputGroup styleName="booking-details__group">

                        <h3 styleName="booking-details__group-heading">Invoice</h3>

                        { this._getInvoicesToSection() }

                        { this._getPurchaseOrderSection() }

                        { this._getInvoiceNumberSection() }

                    </InputGroup>
                </div>
            );
        }
    }

    _getNotesSection() {

        const paymentMethod = this.props.selectedBooking.payment_method;

        if (paymentMethod === 'invoice' || paymentMethod === 'card') {
            const { notes } = this.props.fields;

            return (
                <div>
                    <InputGroup styleName="booking-details__group">

                        <h3 styleName="booking-details__group-heading">Notes</h3>

                        <TextArea className={style['transaction-notes']} {...notes} rows="6" errors={ notes.error } />

                    </InputGroup>

                    { this._getBookingDetailsActions() }
                </div>
            )
        }
    }

    _showBookingDetails(booking) {

        this.props.initializeForm(booking);
        this.props.showBookingDetails(booking);
    }

    _showDeleteTransactionOverlay(booking, event) {

        this.props.showDeleteTransactionOverlay(booking);

        event.preventDefault();
        event.stopPropagation();
    }

    _showEnrollUserOverlay(booking, event) {

        this.props.showEnrollUserOverlay(booking);

        event.preventDefault();
        event.stopPropagation();
    }

    _getDeleteTransactionMessage() {

        if (this.props.bookingToDelete) {

            const formattedBooking = bookingFormatter.format(this.props.bookingToDelete);

            const bookingId = this.props.bookingToDelete.id;
            const deleteDelegates = this.props.isRemoveDelegatesChecked;

            return (
                <article>

                    <p>Are you sure you want to delete this transaction?</p>

                    <div styleName="delete-booking__summary">
                        <span styleName="delete-booking__summary-line">{ formattedBooking.created_at_label }</span>
                        <span styleName="delete-booking__summary-line">{ this._getCourseName(formattedBooking) }</span>
                        <span styleName="delete-booking__summary-line">{ formattedBooking.organisation_name }</span>
                    </div>

                    <InputGroup styleName="delete-booking__options">

                        <Checkbox onChange={ this.props.removeDelegatesCheckboxChanged }
                                  checked={ this.props.isRemoveDelegatesChecked }/>

                        <Label>Remove delegates booked on the course</Label>

                    </InputGroup>

                    <YesNoOptionPanel yes={ this.props.deleteTransaction.bind(this, bookingId, deleteDelegates) }
                                      no={ this.props.hideDeleteTransactionOverlay }/>

                </article>
            );
        }
    }

    _getEnrollUserMessage() {

        if (this.props.bookingToEnroll) {

            const formattedBooking = bookingFormatter.format(this.props.bookingToEnroll);

            const bookingId = this.props.bookingToEnroll.id;
            const attendees = this.props.bookingToEnroll.attendees;

            return (
                <article>

                    <p>Are you sure you want to Enroll the following Users for this booking?</p>

                    <div styleName="delete-booking__summary">
                        <span styleName="delete-booking__summary-line">Course Name: { this._getCourseName(formattedBooking) }</span>
                        <span styleName="delete-booking__summary-line">Organisation Name: { formattedBooking.organisation_name }</span>
                    </div>

                    <InputGroup styleName="booking-details__group">

                        <h3 styleName="booking-details__group-heading">Delegates to Enroll</h3>

                        <table className={style['enroll-attendees-table']}>
                            <tbody>
                            <tr><td>Name</td><td>Email</td></tr>
                            {
                                attendees.map((attendee) => {

                                    return (
                                        <tr key={ attendee.id }>
                                            <td>
                                                { attendee.first_name } { attendee.last_name }
                                            </td>
                                            <td>
                                                { attendee.email }
                                            </td>
                                        </tr>
                                    );
                                })
                            }
                            </tbody>
                        </table>

                    </InputGroup>

                    <YesNoOptionPanel
                        yes={ this.props.enrollUser.bind(this, bookingId) }
                        no={ this.props.hideEnrollUserOverlay }
                        isLoading={this.props.isEnrollingDelegates}
                    />

                </article>
            );
        }
    }

    _getTotalAmountStat() {

        return this.props.stats.totalAmount.toLocaleString(undefined, { minimumFractionDigits: 2 });
    }

    _getMonthTotalStat() {

        return this.props.stats.monthTotal.toLocaleString(undefined, { minimumFractionDigits: 2 });
    }

    _getMonthChangeStat() {

        return this.props.stats.monthChange;
    }

    _getMonthChangeStatComponent() {

        if (this.props.stats.monthChange !== null) {

            return (
                <span styleName="change-stat">({ this._getMonthChangeStat() })</span>
            );
        }
    }

    _searchByEventReference(referenceCode) {

        setQueryParam('referenceCode', referenceCode);

        this.props.filterByReference(referenceCode);
        this.props.refreshBookings();
    }

    _onRemoveDelegate() {

        this.props.hideDeleteDelegateOverlay();
        this.props.refreshBookings();
        this.props.refreshStats();
    }

    _getDownloadAsSpreadsheetButton() {

        if (!this.props.referenceFilter)
            return null;

        const downloadUrl = `/api/v1/transaction-sheet/${this.props.referenceFilter}?token=${ authenticator.getSessionToken() }`;

        return (
            <Button onClick={ () => { window.location = downloadUrl } }>
                Download as spreadsheet
            </Button>
        )
    }

    render() {

        return (
            <div>

                <Overlay isOpen={ this.props.isShowingBookingDetails }
                         closeOverlay={ this.props.hideBookingDetails }
                         title="Booking Details"
                         size="medium">

                    { this._getBookingDetails() }

                </Overlay>

                <RemoveTransactionDelegateOverlay closeOverlay={ this.props.hideDeleteDelegateOverlay }
                                                  onRemoveSuccess={ this._onRemoveDelegate.bind(this) }
                                                  delegate={ this.props.delegateToDelete } />

                <Overlay isOpen={ this.props.isShowingDeleteOverlay }
                         closeOverlay={ this.props.hideDeleteTransactionOverlay }
                         title="Delete Transaction"
                         size="small">

                    { this._getDeleteTransactionMessage() }

                </Overlay>

                <Overlay isOpen={ this.props.isShowingEnrollOverlay }
                         closeOverlay={ this.props.hideEnrollUserOverlay }
                         title="Enrol Users"
                         size="small">

                    { this._getEnrollUserMessage() }

                </Overlay>

                <article styleName="stats-panel">

                    <div styleName="stats-panel__stat">
                        <label styleName="total-amount-label">Total Amount</label>
                        <span styleName="total-amount-value">&pound;{ this._getTotalAmountStat() }</span>
                    </div>

                    <div styleName="stats-panel__stat">
                        <label styleName="total-amount-label">Total Amount (Last 30 Days)</label>
                        <span styleName="total-amount-value">&pound;{ this._getMonthTotalStat() }</span>
                        { this._getMonthChangeStatComponent() }
                    </div>

                </article>

                <InputGroup>

                    <SearchInput styleName="search-input"
                                 initialValue={ this.props.referenceFilter }
                                 onSearch={ this._searchByEventReference.bind(this) }
                                 onReset={ this._searchByEventReference.bind(this, '') }
                                 placeholder="Filter by event reference"/>

                    { this._getDownloadAsSpreadsheetButton() }

                </InputGroup>

                <table styleName="table">

                    <thead>
                    <tr>
                        <th>Date</th>
                        <th>Course</th>
                        <th>Organisation</th>
                        <th>Amount</th>
                        <th>Method</th>
                        <th>Status</th>
                        <th></th>
                    </tr>
                    </thead>

                    <tbody>

                    {
                        this.props.bookings.map((booking, index) => {

                            const formattedBooking = bookingFormatter.format(booking);

                            return (
                                <tr key={ index }
                                    onClick={ this._showBookingDetails.bind(this, booking) }>

                                    <td>{ formattedBooking.created_at_label }</td>
                                    <td>{ this._getCourseName(formattedBooking) }</td>
                                    <td>{ formattedBooking.organisation_name }</td>
                                    <td>£{ formattedBooking.total_charge }</td>
                                    <td>{ formattedBooking.payment_method_label || '–' }</td>

                                    <td styleName="status-cell">
                                        { this._getStatusSelectBox(booking) }
                                    </td>

                                    <td>
                                        <TransparentButton
                                             className={style['enroll-user-button']}
                                            onClick={this._showEnrollUserOverlay.bind(this, booking)}
                                            disabled={booking.payment_method === 'card' || booking.event || booking.is_users_enrolled}
                                        >
                                            <MaterialIcon type="assignment" />
                                            <span>Enrol Users</span>
                                        </TransparentButton>
                                    </td>

                                    <td>
                                        <TransparentButton
                                            className={style['delete-button']}
                                            onClick={this._showDeleteTransactionOverlay.bind(this, booking)}
                                        >
                                            <MaterialIcon type="delete_forever" />
                                            <span>Delete</span>
                                        </TransparentButton>
                                    </td>

                                </tr>
                            );
                        })
                    }

                    </tbody>

                </table>

                <article styleName="stats-panel">
                    <TransparentButton
                        className={style['load-more-button']}
                        onClick={this.props.loadMoreBookings.bind(this)}
                    >
                        <span>Load More</span>
                    </TransparentButton>
                </article>
            </div>
        );
    }
}

const formOptions = {
    form: 'bookings',
    fields: [
        'id',
        'po_number',
        'invoice_number',
        'notes'
    ]
};

function mapStateToProps(state) {

    return {
        ...state.bookingList
    };
}

function mapDispatchToProps(dispatch) {

    return {
        hideDeleteDelegateOverlay() {

            dispatch(bookingActions.hideDeleteDelegateOvelray());
        },
        selectDelegateForDeletion(delegate) {

            dispatch(bookingActions.selectDelegateForDeletion(delegate));
        },
        removeDelegatesCheckboxChanged() {

            dispatch(bookingActions.removeDelegatesCheckboxChanged());
        },
        deleteTransaction(bookingId, deleteDelegates) {

            dispatch(bookingActions.deleteTransaction(bookingId, deleteDelegates));
        },
        enrollUser(bookingId) {
            dispatch(bookingActions.enrollUser(bookingId));
        },
        hideDeleteTransactionOverlay() {

            dispatch(bookingActions.hideDeleteTransactionOverlay());
        },
        hideEnrollUserOverlay() {
            dispatch(bookingActions.hideEnrollUserOverlay());
        },
        showDeleteTransactionOverlay(booking) {

            dispatch(bookingActions.showDeleteTransactionOverlay(booking));
        },
        showEnrollUserOverlay(booking) {
            dispatch(bookingActions.showEnrollUserOverlay(booking));
        },
        filterByReference(referenceCode) {

            dispatch(bookingActions.filterByReference(referenceCode));
        },
        bookingDetailsUpdated() {

            dispatch(bookingActions.hideBookingDetails());
        },
        showBookingDetails(booking) {

            dispatch(bookingActions.showBookingDetails(booking));
        },
        hideBookingDetails() {

            dispatch(bookingActions.hideBookingDetails());
        },
        updateBooking(booking) {

            dispatch(bookingActions.updateBooking(booking));
        },
        refreshBookings() {

            dispatch(bookingActions.refreshBookings());
        },
        loadMoreBookings() {

            dispatch(bookingActions.loadMoreBookings());
        },
        refreshStats() {

            dispatch(bookingActions.refreshStats());
        }
    };
}

export default reduxForm(formOptions, mapStateToProps, mapDispatchToProps)(CSSModules(TransactionList, style));


// WEBPACK FOOTER //
// ./components/TransactionList/index.js